// extracted by mini-css-extract-plugin
module.exports = {"customHeader":"CustomHeader_customHeader__LgTkr","customHeaderDown":"CustomHeader_customHeaderDown__1xt6d","suggestionsContainer":"CustomHeader_suggestionsContainer__c2M3D"};